import { PropsWithChildren } from 'react';

import { Dialog } from '@mui/material';

import { tokens } from '../../../theme/generated/tokens';
import { useCloseDialog } from '../hooks/useCloseDialog';

type DialogBaseProps = PropsWithChildren<{
  closeOnOverlayClick?: boolean;
}>;

export const DialogBase = ({
  closeOnOverlayClick,
  children,
}: DialogBaseProps) => {
  const closeDialog = useCloseDialog();
  const handleClose = (_event: object, reason: string) => {
    if (!closeOnOverlayClick && reason === 'backdropClick') {
      return;
    }
    closeDialog();
  };
  return (
    <Dialog
      open
      onClose={handleClose}
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: tokens.theme.bg.structural.overlay,
          },
        },
      }}
      PaperProps={{
        sx: { backgroundColor: 'transparent' },
      }}
    >
      {children}
    </Dialog>
  );
};
